import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_KEY,
    authDomain: "our-subscribers.firebaseapp.com",
    projectId: "our-subscribers",
    storageBucket: "our-subscribers.firebasestorage.app",
    messagingSenderId: "658483847107",
    appId: process.env.REACT_APP_FIREBASE_APP_ID,

};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

